import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import type { ReactNode } from "react";
import Spinner from "@/components/utils/Spinner";
import type { TokenMetadata } from "@/types/nft";
interface XtdhTokenListItemThumbnailProps {
  readonly tokenLabel: string;
  readonly metadata?: TokenMetadata | undefined;
  readonly isLoading: boolean;
  readonly hasError: boolean;
}
export function XtdhTokenListItemThumbnail(t0) {
  const $ = _c(9);
  const {
    tokenLabel,
    metadata,
    isLoading,
    hasError
  } = t0;
  let content;
  if (metadata?.imageUrl) {
    const t1 = metadata.name ?? tokenLabel;
    let t2;
    if ($[0] !== metadata.imageUrl || $[1] !== t1) {
      t2 = <Image src={metadata.imageUrl} alt={t1} fill={true} sizes="48px" className="tw-h-full tw-w-full tw-object-cover tw-flex-shrink-0" />;
      $[0] = metadata.imageUrl;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    content = t2;
  } else {
    if (isLoading) {
      let t1;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center"><Spinner /></div>;
        $[3] = t1;
      } else {
        t1 = $[3];
      }
      content = t1;
    } else {
      if (hasError) {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-text-[10px] tw-font-semibold tw-text-red-300">Error</div>;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        content = t1;
      } else {
        let t1;
        if ($[5] !== tokenLabel) {
          t1 = <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-text-xs tw-text-iron-400">{tokenLabel}</div>;
          $[5] = tokenLabel;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        content = t1;
      }
    }
  }
  let t1;
  if ($[7] !== content) {
    t1 = <div className="tw-relative tw-h-12 tw-w-12 tw-overflow-hidden tw-rounded-lg tw-bg-iron-800 tw-flex-shrink-0">{content}</div>;
    $[7] = content;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}